import React, { useState } from "react";
import "./Toolbar.css";

function Toolbar({
  isVisible,
  hasDrawings,
  historyLength,
  redoStackLength,
  onToolSelect,
  onAnalyze,
  onUndo,
  onRedo,
  onClearAll,
}) {
  const [showShapesMenu, setShowShapesMenu] = useState(false);

  return (
    <div className={`toolbar-container ${isVisible ? "" : "hidden"}`}>
      <div className="main-tools">
        <button
          id="polygon-tool"
          className="tool-button"
          title="Polygon Tool"
          onClick={() => onToolSelect("polygon")}
        >
          <i className="fa-solid fa-draw-polygon"></i>
        </button>
        <button
          id="free-draw-tool"
          className="tool-button"
          title="Free Draw"
          onClick={() => onToolSelect("freeDraw")}
        >
          <i className="fa-solid fa-signature"></i>
        </button>
        <button
          id="radius-tool"
          className="tool-button"
          title="Radius Tool"
          onClick={() => onToolSelect("radius")}
        >
          <i className="fa-solid fa-bullseye"></i>
        </button>
        <div style={{ position: "relative" }}>
          <button
            id="shapes-tool"
            className="tool-button"
            title="More Shapes"
            onClick={() => setShowShapesMenu(!showShapesMenu)}
          >
            <i className="fa-solid fa-shapes"></i>
          </button>
          <div
            id="shapes-menu"
            className={`shapes-menu ${showShapesMenu ? "" : "hidden"}`}
          >
            <button
              id="circle-tool"
              className="tool-button"
              title="Circle Tool"
              onClick={() => {
                onToolSelect("circle");
                setShowShapesMenu(false);
              }}
            >
              <i className="fa-regular fa-circle"></i>
            </button>
            <button
              id="rectangle-tool"
              className="tool-button"
              title="Rectangle Tool"
              onClick={() => {
                onToolSelect("rectangle");
                setShowShapesMenu(false);
              }}
            >
              <i className="fa-regular fa-square"></i>
            </button>
            <button
              id="triangle-tool"
              className="tool-button"
              title="Triangle Tool"
              onClick={() => {
                onToolSelect("triangle");
                setShowShapesMenu(false);
              }}
            >
              <i className="fa-solid fa-play fa-rotate-270"></i>
            </button>
          </div>
        </div>
      </div>
      <div className={`contextual-actions ${hasDrawings ? "visible" : ""}`}>
        <button
          id="analyze-tool"
          className="tool-button"
          title="Analyze Area"
          disabled={!hasDrawings}
          onClick={onAnalyze}
        >
          <i className="fa-solid fa-wand-magic-sparkles"></i>
        </button>
        <button
          id="undo-tool"
          className="tool-button"
          title="Undo"
          disabled={historyLength === 0}
          onClick={onUndo}
        >
          <i className="fa-solid fa-rotate-left"></i>
        </button>
        <button
          id="redo-tool"
          className="tool-button"
          title="Redo"
          disabled={redoStackLength === 0}
          onClick={onRedo}
        >
          <i className="fa-solid fa-rotate-right"></i>
        </button>
        <button
          id="clear-all-tool"
          className="tool-button"
          title="Clear All Drawings"
          disabled={!hasDrawings}
          onClick={onClearAll}
        >
          <i className="fa-solid fa-eraser"></i>
        </button>
      </div>
    </div>
  );
}

export default Toolbar;
